import { useQuery } from '@tanstack/react-query';
import api from '../api/client';

export function usePlatformPermissions() {
  const { data, isLoading } = useQuery({
    queryKey: ['platform-permissions'],
    queryFn: async () => {
      const res = await api.platform.getMyPlatformPermissions();
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  const platformPerms = data || null;

  return {
    isPlatformUser: !!platformPerms?.is_platform_user,
    platformRoles: platformPerms?.platform_roles || [],
    platformPermissions: platformPerms?.platform_permissions || {},

    isSaasOwner: platformPerms?.platform_roles?.includes('saas_owner') || false,
    isPlatformAdmin: platformPerms?.platform_roles?.includes('platform_admin') || false,
    isSupportStaff: platformPerms?.platform_roles?.includes('support_staff') || false,

    canAccessAllCompanies: platformPerms?.platform_permissions?.can_access_all_companies || false,
    canImpersonateUsers: platformPerms?.platform_permissions?.can_impersonate_users || false,
    canViewPlatformAnalytics: platformPerms?.platform_permissions?.can_view_platform_analytics || false,
    canManagePlatformSettings: platformPerms?.platform_permissions?.can_manage_platform_settings || false,
    canAccessSupportMode: platformPerms?.platform_permissions?.can_access_support_mode || false,

    isLoading,
  };
}
